import { TableDefinition } from "../../model/TableDefinition";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseTableDefinitionFactory } from "../../model/BaseTableDefinitionFactory";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class BaseBlotterDataAdapter {
  protected tableDefinition: TableDefinition;
  constructor(protected _tableDefinitionFactory: BaseTableDefinitionFactory) {
    _tableDefinitionFactory.defineTable().then(
      (value) => {
        this.tableDefinition = value;
      },
      (reason: string) => {
        logger.out.info("_tableDefinitionFactory.defineTable rejection: " + reason);
      },
    );
  }
}
